import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "p-2" }

import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount, reactive, ref } from 'vue'
    import { ElMessageBox, ElForm, ElFormItem, ElInput, ElButton, FormInstance, FormRules } from 'element-plus';
    import { useStore } from 'vuex';
    import { TravelCompany } from '@/services/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompaniesView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const data = ref<Array<TravelCompany>>([])
    const formRef = ref<FormInstance>()

    const rules = reactive<FormRules<{q: string, dates: Array<string>}>>({
        q: [{required: false, message: 'Selecione a imagem'}],
    })

    const searchData = reactive<{q: string, dates: Array<string>}>({q: '', dates: []})

    const getCompanies = async (q: string | false = false) => {
        loading.value = true
        const params = new URLSearchParams()
        if (q && q.trim().length > 0) {
            params.append('q', q)
        } 
        const res = await Api.get(`admin/travel-companies?${params.toString()}`)
        if (res.status == 200) {
            console.log(res.data)
            data.value = res.data.companies
        } else {
            console.log(res)
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }

    const search = async () => {
        loading.value = true
        await getCompanies(searchData.q)
    }
    onBeforeMount(async () => {
        await getCompanies()
    })

    const store = useStore()
    store.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 6) {
            // new product
            await getCompanies()
        }
    })

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Transportadoras" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          ref_key: "formRef",
          ref: formRef,
          "label-position": "top",
          inline: "",
          model: searchData,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElFormItem), {
              label: "pesquisar empresas de transporte",
              class: "col-12 col-md-4 col-lg-3",
              prop: "q"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  name: "q",
                  modelValue: searchData.q,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchData.q) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElFormItem), { label: "buscar" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  loading: loading.value,
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("Procurar", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createVNode(PersonalTable, {
          loading: loading.value,
          height: 450,
          showRows: 10,
          cols: [
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
            ],
          data: data.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Local",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.description.substring(0, 20)) + "... ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Local",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.area.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Adicionada em",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(new Date(data.row.created_at).toLocaleString("pt")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Acções",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    tag: "router-link",
                    to: '/companies/' + data.row.id,
                    icon: "View",
                    title: "Ver mais"
                  }, null, 8, ["to"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "data"])
      ]),
      _: 1
    })
  ]))
}
}

})